import nftSaga from './saga';
import { reduxModuleLoaded } from './actions';
export function getModule() {
    return {
        id: 'nft',
        reducerMap: {},
        sagas: [
            nftSaga
        ],
        initialActions: [
            reduxModuleLoaded()
        ],
        retained: true
    };
}
